import { ButtonAPI, FieldAPI, InputAPI, PanelAPI, RecaptchaAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnClose, OnClick, OnChange, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import ResetPasswordService from '../../services/reset-password-service';
import BaseController from '../BaseController';

import { Inject } from '@odinjs/odin';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { getCatpchaPublicKey } from '../../utils/captcha-utils';

@Controller({ fragment: 'forget-password', component: 'root-modal' })
class ForgetPasswordController extends BaseController {

  @Inject('recaptcha')
  recaptcha: RecaptchaAPI;

  @Inject('email-input')
  emailInput: InputAPI;

  @Inject('confirm-button')
  confirmBtn: ButtonAPI;

  @Inject('email-field')
  emailField: FieldAPI;

  @Inject('panel-loader-action')
  panelLoader: PanelAPI;

  @OnMount({ target: 'recaptcha'})
  async onMountRecaptcha(event: MountEvent): Promise<void> {
    const recaptcha = event.target as RecaptchaAPI;
    const publicKey = await getCatpchaPublicKey();
    recaptcha.setSiteKey(publicKey);
  }

  @OnMount({ target: ['panel-loader-action'] })
  onMountLoader(): void {
    this.panelLoader.setVisible(false);
  }

  @OnClick({ target: ['confirm-button'] })
  onClickConfirmButton(): void {
    if (this.emailInput.getValue() && this.recaptcha.getValue()) {
      this.confirmBtn.setEnabled(false);
      this.panelLoader.setVisible(true);

      ResetPasswordService.recoverPassword(this.emailInput.getValue() as string)
        .then(() => {
          this.historyService.push(APPLICATION_ROUTES.FORGET_PASSWORD_REQUEST_SUCCESS);
        })
        .catch(() => {
          this.historyService.push(APPLICATION_ROUTES.FORGET_PASSWORD_REQUEST_FAILURE);
        });
    }
  }

  @OnChange({ target: ['recaptcha'] })
  async onChangeRecaptcha(): Promise<void> {
    if (await this.emailField.validate() && this.recaptcha.getValue()) {
      this.confirmBtn.setEnabled(true);
    } else {
      this.confirmBtn.setEnabled(false);
    }
  }

  @OnChange({ target: ['email-field'] })
  async onChangeEmail(): Promise<void> {
    if (await this.emailField.validate() && this.recaptcha.getValue()) {
      this.confirmBtn.setEnabled(true);
    } else {
      this.confirmBtn.setEnabled(false);
    }
  }

  @OnClose({ target: 'root-modal' })
  onRootModalClose(): void {
    this.historyService.push(APPLICATION_ROUTES.LOGIN);
  }
}

export default ForgetPasswordController;
